import { render, staticRenderFns } from "./Iujp.vue?vue&type=template&id=78528ff6&"
import script from "./Iujp.vue?vue&type=script&lang=js&"
export * from "./Iujp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports